// extracted by mini-css-extract-plugin
export var close = "searchResults-module--close--2Ap8+";
export var heading = "searchResults-module--heading--X1nRx";
export var label = "searchResults-module--label--KxtdN";
export var result = "searchResults-module--result--ioJND";
export var resultContainer = "searchResults-module--resultContainer--mxTKw";
export var section = "searchResults-module--section--rAnGp";
export var show = "searchResults-module--show--hpvrU";
export var text = "searchResults-module--text--gClZG";